import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface DomainQueryParams {
  key_word: string
  group_id: number
  asc?: boolean
  sort: string
  page: number
  limit: number
}

export interface DomainInfo {
  domain: string // 域名
  first_intercept_time: number // 首次拦截时间
  count: number // 拦截次数
}

export interface DetailQueryParams {
  domain: string // 域名
  key_word: string
  group_id: number
  page: number
  limit: number
  /** 策略id */
  strategy_id?: string
  /** 拦截明细时间范围（Unix 秒） */
  start_time?: number
  end_time?: number
}

export interface DetailInfo {
  device_id: number // 终端id
  computer_name: string // 计算机名
  user_mark: string // 登记用户名
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  intercept_time: number // 拦截时间
  /** 终端状态，1：在线，2：离线 */
  login_status: string
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  /** 触发策略 */
  strategy_name?: string
}

@Injectable()
export class DomainViewService {
  constructor (private http: Http) {

  }

  @ParamsClean()
  @InvokeThrottle()
  getDomainList (params: DomainQueryParams) {
    return this.http.post<{
      total: number
      list: DomainInfo[]
    }>('/terminal/domain-limit/stat', params)
  }

  @ParamsClean()
  @InvokeThrottle()
  getDetailList (params: DetailQueryParams) {
    return this.http.post<{
      total: number
      list: DetailInfo[]
    }>('/terminal/domain-limit/list', params)
  }

  download (type: 0|1, options: DetailQueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/terminal/domain-limit/list/export', params, moduleName)
  }
}
